export const SIDEBAR_KEY = 'sidebarStatus'
export const LANGUAGE_KEY = 'language'
export const JWT_KEY = 'jwt'
